import React, { useEffect, useState } from "react";
import Select from "react-select";
import axios from "axios";
import MasterLayout from "../masterLayout/MasterLayout";
import { API_URL, LOCATION_ID } from "..";
import { Icon } from "@iconify/react";

const AssetReport = () => {
  const today = new Date();
  const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);

  const formatDate = (d) => d.toISOString().split("T")[0];

  const [fromDate, setFromDate] = useState(formatDate(firstDay));
  const [toDate, setToDate] = useState(formatDate(today));
  const [loading, setLoading] = useState(false);
  const [reports, setReports] = useState([]);
  const [accounts, setAccounts] = useState([]);
const [selectedAccount, setSelectedAccount] = useState(null);

useEffect(() => {
  const fetchAccounts = async () => {
    const location_id = LOCATION_ID
    try {
      const res = await fetch(`${API_URL}/api/accounts/location/${location_id}`);
      const data = await res.json();

      if (data.accounts) {
        setAccounts(
          data.accounts.map(a => ({
            value: a.id,
            label: `${a.type.toUpperCase()} - ${a.accountTitle || a.bankAccountTitle} (${a.accountNo || a.bankAccountNo})`,
          }))
        );
      }
    } catch (err) {
      console.error("Failed to load accounts", err);
    }
  };

  fetchAccounts();
}, []);


  // Report types
  const reportTypes = [
    { value: "SalesReport", label: "Sales Report" },
    { value: "PurchaseReport", label: "Purchase Report" },
    { value: "ExpenseReport", label: "Expense Report" },
    { value: "ProfitLossReport", label: "Profit & Loss Report" },
    { value: "AccountReport", label: "Account Report" },
    { value: "LedgerReport", label: "Ledger Report" },
  ];

      const locationId = LOCATION_ID
  
  // Correct default
  const [selectedReport, setSelectedReport] = useState(reportTypes[0]);

  // Load reports
  const loadReportsList = async () => {
    try {
      const res = await axios.get(`${API_URL}/api/reports?locationId=${locationId}`);
      const data = res.data.reports
      // setReports(res.data.reports || []);
      setReports(data.filter((e)=>e.reportType === 'Asset Report'));
      
    } catch (err) {
      console.error("Load report error:", err);
    }
  };

  useEffect(() => {
    loadReportsList();
  }, []);

  // Generate Report
  const generateReport = async () => {
  if (!selectedReport) {
    alert("Please select report type");
    return;
  }

  if (selectedReport.value === "AccountReport" && !selectedAccount) {
    alert("Please select an account for Account Report!");
    return;
  }

  setLoading(true);

  try {
    const payload = {
      reportType: 'AssetReport',
      startDate: fromDate,
      endDate: toDate,
      user_id: 1,
    };

    // ⭐ Add account_id if needed
    if (selectedReport.value === "AccountReport") {
      payload.account_id = selectedAccount.value;
    }

    const res = await axios.post(`${API_URL}/api/reports/generate/${locationId}`, payload);

    // alert("Report generated!");
    loadReportsList();
  } catch (err) {
    console.error(err);
    alert("Failed to generate report.");
  }

  setLoading(false);
};


  // Delete Report
  const deleteReport = async (id) => {
    if (!window.confirm("Delete this report?")) return;
    try {
      await axios.delete(`${API_URL}/api/reports/${id}`);
      loadReportsList();
    } catch (err) {
      // alert("Deletion failed");
    }
  };

  return (
    <MasterLayout>
      <div className="container py-4">

        {/* PAGE TITLE */}
        <div className="text-center mb-4">
          {/* <h2 className="fw-bold">Reports Management</h2>
          <p className="text-muted">Generate & download reports in one place</p> */}
        </div>

        {/* ========================== */}
        {/* GENERATE REPORT CARD */}
        {/* ========================== */}
        <div className="card border-0 shadow-sm mb-8" style={{ borderRadius: "14px" }}>
          <div className="card-body">

            <h5 className="fw-bold mb-3">Generate Assets Report</h5>

            <div className="row g-3">

              <div className="col-md-3">
                <label className="form-label">From Date</label>
                <input
                  type="date"
                  className="form-control"
                  value={fromDate}
                  onChange={(e) => setFromDate(e.target.value)}
                />
              </div>

              <div className="col-md-3">
                <label className="form-label">To Date</label>
                <input
                  type="date"
                  className="form-control"
                  value={toDate}
                  onChange={(e) => setToDate(e.target.value)}
                />
              </div>

              {/* <div className="col-md-4">
                <label className="form-label">Report Type</label>
                <Select
                  options={reportTypes}
                  value={selectedReport}
                  onChange={setSelectedReport}
                />
              </div>
              {selectedReport?.value === "AccountReport" && (
  <div className="col-md-4">
    <label className="form-label">Select Account</label>
    <Select
      options={accounts}
      value={selectedAccount}
      onChange={setSelectedAccount}
      placeholder="Select an Account"
    />
  </div>
)} */}


              <div className="col-md-2 d-flex align-items-end">
                <button
                  className="btn btn-primary w-100"
                  onClick={generateReport}
                  disabled={loading}
                >
                  {loading ? "Generating..." : "Generate"}
                </button>
              </div>

            </div>
          </div>
        </div>

        {/* ========================== */}
        {/* REPORT LIST */}
        {/* ========================== */}
        <div className="card border-0 shadow-sm" style={{ borderRadius: "14px" }}>
          <div className="card-body">
            <h5 className="fw-bold mb-3">Generated Reports</h5>

            {reports.length === 0 ? (
              <p className="text-muted">No reports found.</p>
            ) : (
              <div className="table-responsive">
                <table className="table table-hover align-middle">
                  <thead className="bg-light">
                    <tr>
                      <th>#</th>
                      <th>Type</th>
                      <th>Date Range</th>
                      <th>Created At</th>
                      <th>Download</th>
                      <th>Delete</th>
                    </tr>
                  </thead>

                  <tbody>
                    {reports.map((rep, i) => (
                      <tr key={rep.id}>
                        <td>{i + 1}</td>

                        <td>
                          <span className="badge bg-info px-3 py-2">
                            {rep.reportType}
                          </span>
                        </td>

                        <td>{rep.reportDate}</td>
                        <td>{new Date(rep.createdAt).toLocaleString()}</td>

                        <td>
                          <a
                            href={API_URL + rep.fileUrl}
                            target="_blank"
                            className="btn btn-success btn-sm"
                          >
                            <Icon icon="mdi:download" /> Download
                          </a>
                        </td>

                        <td>
                          <button
                            className="btn btn-danger btn-sm"
                            onClick={() => deleteReport(rep.id)}
                          >
                            <Icon icon="mdi:trash-can" /> Delete
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}

          </div>
        </div>
      </div>
    </MasterLayout>
  );
};

export default AssetReport;
